import {Button} from "primereact/button";
import {utils, writeFile} from "xlsx";

const ExportButton = ({data, columns, fileName = "export"}) => {
	const exportToExcel = () => {
		const exportData = data.map((row, index) => {
			const rowData = {};

			columns.forEach((col) => {
				// Handling for index column
				if (col.key === "index") {
					rowData[col.label] = index + 1;
					return;
				}

				// For fields with special processing, use the field property
				if (col.field) {
					rowData[col.label] = col.field(row);
					return;
				}

				// For normal keys that need deep path access
				if (col.key) {
					const keys = col.key.split(".");
					let value = row;

					// Navigate through nested object properties
					for (const key of keys) {
						if (value && key in value) {
							value = value[key];
						} else {
							value = undefined;
							break;
						}
					}

					rowData[col.label] = value !== undefined ? value : "";
				}
			});

			return rowData;
		});

		const worksheet = utils.json_to_sheet(exportData);
		const workbook = utils.book_new();
		utils.book_append_sheet(workbook, worksheet, "Sheet1");
		writeFile(workbook, `${fileName}.xlsx`);
	};

	return (
		<Button
			className="min-w-[100px] h-[42px] px-2 py-1 text-white bg-[#247D4F] rounded-md hover:bg-opacity-90 flex items-center text-center leading-none justify-center"
			label="Excel"
			icon="pi pi-file-excel"
			onClick={exportToExcel}
		/>
	);
};

export default ExportButton;
